// extracted by mini-css-extract-plugin
export var divider = "_xt-0";